import { render, staticRenderFns } from "./UserActivitiesPage.vue?vue&type=template&id=fe1617dc"
import script from "./UserActivitiesPage.vue?vue&type=script&lang=js"
export * from "./UserActivitiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports